(function() {
  'use strict';

  angular
    .module('app.dialogs', [])
    .config(config);
    
  config.$inject = ['$mdDialogProvider'];
    
  function config($mdDialogProvider) {
    $mdDialogProvider.addPreset('marsConfirm', {
      options: function () {
        return {
          templateUrl: 'app/core/dialogs/mars-confirm.html',
          controller: 'MarsConfirmController as vm',
          clickOutsideToClose: true
        };
      }
    });
  }
  
})();